export default "__VITE_ASSET__Bia988mw__"